  import * as React from 'react';

  import { useState } from "react";
  import Dialog from '@mui/material/Dialog';
  import DialogTitle from '@mui/material/DialogTitle';
  import DialogContent from '@mui/material/DialogContent';
  import AITestContext from '../../../contexts/AITestContext';
  import StatusContext from '../../../contexts/StatusContext';

  import IconButton from '@mui/material/IconButton';
  import CloseIcon from '@mui/icons-material/Close';
  
  export const DialogTestLanguage = ({requesttests}) => {
    const [hoveredIndex, setHoveredIndex] = useState(-1); // Default to -1 (no hover)
    
   
    const languages = [
      "English",
      "Arabic",
      "Chinese",
      "Czech",
      "Danish",
      "French",
      "German",
      "Greek",
      "Hungarian",
      "Italian",
      "Japanese",
      "Korean",
      "Polish",
      "Portuguese",
      "Romanian",
      "Russian",
      "Serbian",
      "Spanish",
      "Swedish",
      "Turkish",
      ]

const {
 changeLanguage,
         
} = React.useContext(StatusContext);

  const {
   setLanguage,
   showTestLanguages,
   setShowTestLanguages,
   onChangeLanguage,
} = React.useContext(AITestContext);


const styles = {
  container1: {
    alignItems: 'center', // Center vertically
 
    padding: '10px',
    marginBottom: '10px',
    width: '100%',
    border:'none',
    cursor: 'pointer',
    backgroundColor: (index) => (hoveredIndex === index ? 'lightcoral' : 'lightblue'), // Change color based on hovered index
    transition: 'background-color 0.3s ease', // Optional transition for smooth effect
    },

    item: {
      
      alignItems: 'center', // Center vertically
      textAlign: 'center',
      color: 'maroon',
      borderRadius: '5px',
     
      padding: '5px',
      marginBottom: '10px',
      width: '100%',
      border:'none',
      cursor: 'pointer',
      backgroundColor: (index) => (hoveredIndex === index ? 'lightcoral' : 'lightblue'), // Change color based on hovered index
      transition: 'background-color 0.3s ease', // Optional transition for smooth effect
      },
  title: {
    display: 'flex',
    color: 'rgb(138, 57, 57)',
    fontSize: '26px',
    marginTop:'-25px',
    marginBottom: '-15px',
    justifyContent: 'center',
  },
  
  text: {
  
    color: 'rgb(138, 57, 57)',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom:'15px',
    justifyContent: 'center',
    textAlign:'center',
  },
  savebutton: {
   
    justifyContent: 'center',
  }
 
}

  const onSelectLanguage = (index) => {
    console.log("selected Language:", languages[index])
    setLanguage(languages[index])
   
    onChangeLanguage(languages[index])
   
    handleClose()
  }

  
  const handleClose = (event, reason) => {
   
  
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      // Handle the backdrop click event here
      return
    }

    setShowTestLanguages(false)
  
  };


    return (
    
      <React.Fragment>
    
          <Dialog
            open={showTestLanguages}
          
            PaperProps={{
              component: 'form',
              onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const email = formJson.email;
                console.log(email);
                
              },
            }}
          >

          <DialogTitle style = {{fontSize:'14px'}}>
         
          </DialogTitle>

       
      
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
          <CloseIcon />
        </IconButton>

        <br></br>
      
        <DialogTitle style = {styles.title}>
            {changeLanguage('aitest', 'selecttestlanguage')}
         
        </DialogTitle>
        
        
          <DialogContent dividers>
          
              
                <div>
                {
                  Array.isArray(languages) &&
                    languages.map((item, index) => (
                      <div key = {index} 
                        style={{ ...styles.item, backgroundColor: styles.item.backgroundColor(index) }}
                        onClick={()=>onSelectLanguage(index)}
                        onMouseEnter={() => setHoveredIndex(index)} // Set hover state to true
                        onMouseLeave={() => setHoveredIndex(-1)} // reset
                      >
                      <span>{languages[index]}</span>
                      <br></br>
                      </div>
                  ))
                }
              
               </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      
    );
    
  }

  DialogTestLanguage.defaultProps = {
  requesttests: false,
}